import { render } from "./tracking-depara.vue?vue&type=template&id=d3557d32"
import script from "./tracking-depara.vue?vue&type=script&lang=js"
export * from "./tracking-depara.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__